<template>
    <PageTitleComponent><font-awesome-icon :icon="['fas', 'screwdriver-wrench']" /> 管理メニュー</PageTitleComponent>

    <div class="container mt-3">
        <div class="row g-3">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title">スコア登録</h5>
                        <p class="card-text">試合のスコアを登録します</p>
                        <RouterLink class="btn btn-primary" to="/match">移動</RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title">スコア一覧（旧画面）</h5>
                        <p class="card-text">スコアの一覧を表示します</p>
                        <RouterLink class="btn btn-primary" to="/match/list">移動</RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title">試合開始（QR）</h5>
                        <p class="card-text">QRコードで試合を開始します</p>
                        <RouterLink class="btn btn-primary" to="/match/start">移動</RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title">試合結果入力（QR）</h5>
                        <p class="card-text">QRコードで試合結果を入力します</p>
                        <RouterLink class="btn btn-primary" to="/match/finish">移動</RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title">エントリー修正</h5>
                        <p class="card-text">エントリー情報を修正します</p>
                        <RouterLink class="btn btn-primary" to="/entry/event">移動</RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title">ログアウト</h5>
                        <p class="card-text">ログアウトします</p>
                        <button class="btn btn-danger" @click="doLogout">ログアウト</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <span class="text-muted">{{ user.email }}</span>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { RouterLink, RouterView } from 'vue-router'
import PageTitleComponent from '@/components/PageTitleComponent.vue'
import { getAuth, signOut } from "firebase/auth";
const auth = getAuth();
const user = auth.currentUser;

const doLogout = () => {
    signOut(auth)
        .then(() => {
            console.log("Sign-out successful.");
        })
        .catch((err) => {
            console.log(err.message);
        });
}

</script>

<style scoped>

div {
    font-size: 13pt;
}
</style>